var exports = {
  "kL": "VoiceControlBar.module__container___eHN4aT",
  "UD": "VoiceControlBar.module__buttonContainer___eHN4aT",
  "x6": "VoiceControlBar.module__button___eHN4aT",
  "QV": "VoiceControlBar.module__buttonMuted___eHN4aT",
  "rp": "VoiceControlBar.module__buttonUnmuted___eHN4aT",
  "Jt": "VoiceControlBar.module__buttonDeafened___eHN4aT",
  "Zj": "VoiceControlBar.module__buttonCameraOn___eHN4aT",
  "PQ": "VoiceControlBar.module__buttonCameraOff___eHN4aT",
  "bt": "VoiceControlBar.module__buttonScreenShareOn___eHN4aT",
  "fB": "VoiceControlBar.module__buttonScreenShareOff___eHN4aT",
  "f4": "VoiceControlBar.module__buttonRoomOn___eHN4aT",
  "nU": "VoiceControlBar.module__buttonRoomOff___eHN4aT",
  "_p": "VoiceControlBar.module__buttonMoreOptions___eHN4aT",
  "Zt": "VoiceControlBar.module__buttonDisconnect___eHN4aT",
  "Q1": "VoiceControlBar.module__buttonSeparator___eHN4aT",
  "Se": "VoiceControlBar.module__settingsButton___eHN4aT",
  "on": "VoiceControlBar.module__stopWatchingButton___eHN4aT",
  "Kk": "VoiceControlBar.module__icon___eHN4aT",
  "Bx": "VoiceControlBar.module__iconSmall___eHN4aT",
};

module.exports = exports;
